
//是否已订阅
let hasSubscription = false;
/**
 * 数据类型
 * @readonly
 * @enum {string}
 */
const showType = {
    "string":"string",
    "boolean":"boolean"
}


export default function (val) {
    let { pen } = val;
    let Auth = this.proc.make('Auth');
    let device = Auth.device;
    let mqtt = this.proc.make('MQTT');
    // 关闭已有监听
    mqtt.off('subscribe.success');
    let DPC = this.proc.make('DPC');

    let topo = this.proc.make('TechnologyTopo');
    let pushtopic = `Hexu/${device.deviceNo}/DevicePub`;
    let subtopic = `Hexu/${device.deviceNo}/DeviceSub`;
    
    let msgData = []
    pen.events.forEach(item=>{
        console.log(item)
        if(item.msgData){
            item.msgData.forEach(s=>{
                let obj = {
                    key:s.key,
                    value:s.value
                }
                msgData.push(obj)
            })
        }
        
    })
    let data = {}

    // 处理消息列表
    msgData.forEach(item => {
        let SettingValue = item.key.formula.SettingValue
        let key = item.key;
        if(typeof key === 'object'){
            switch(key.showType){
                case showType.string:
                    data[SettingValue] = item.value;
                    break;
                case showType.boolean:
                    data[SettingValue] = item.value ? 1 : 0;
                    break;
            }
        }else{
            data[key] = item.value
        }
    })
    //只订阅一次
    if(!hasSubscription){
        hasSubscription = true;
        mqtt.mqtt.subscriptionApi({topic:pushtopic}, (_data) => {
            console.log('订阅消息', _data)
        })
    }
    
    mqtt.mqtt.send(subtopic,{
        "uuid": device.deviceNo,
        "action": "writedata",
        "ts": new Date(),
        "data": data
    });

    DPC.proc.watch("modules", (val) => {
        // console.log("数据有更新");
        topo.update(val)
    });
    
    // mqtt离线
    if (!mqtt.mqtt.Client.isConnected()) {
        mqtt.mqtt.connect()
    } 

}